import { GrapevineSpecialPostEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineSpecialPostEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineSpecialPostEventsApi(configuration),
    [configuration]
  );
};
